// common and reused functions

export function isNumber(value) {
  return value === ('' || null) ? false : !isNaN(value);
}

export const filterValidation = (filterValue) => {
  return !!filterValue && isNumber(filterValue);
};

export function hasPassed5AMUTC() {
  const now = new Date();

  // Get the current day of the week in UTC
  const weekDay = now.getUTCDay();

  // Get the current time in UTC
  const currentHours = now.getUTCHours();
  const currentMinutes = now.getUTCMinutes();
  const currentSeconds = now.getUTCSeconds();

  // Check if the current time has passed 5 AM UTC
  const hasPassed5AM =
    currentHours > 5 || (currentHours === 5 && (currentMinutes > 0 || currentSeconds > 0));
  return { weekDay, hasPassed5AM };
}

export function findFiscalMonthAndWeek(weekObject) {
  const inputDateObj = new Date();
  const { weekDay, hasPassed5AM } = hasPassed5AMUTC();

  const dayOfWeek = inputDateObj.getDay();
  const daysUntilTuesday = ((2 - dayOfWeek + 7) % 7) - 7;
  const tuesdayDate = new Date(inputDateObj);
  tuesdayDate.setDate(inputDateObj.getDate() + daysUntilTuesday);

  const currentDate = new Date(
    inputDateObj.getFullYear(),
    inputDateObj.getMonth(),
    inputDateObj.getDate() - 7
  );

  const daysUntilTuesdayTwoWeeksAgo = ((2 - dayOfWeek + 7) % 7) - 14;
  const tuesdayDateTwoWeeksAgo = new Date(inputDateObj);
  tuesdayDateTwoWeeksAgo.setDate(inputDateObj.getDate() + daysUntilTuesdayTwoWeeksAgo);

  const currentDateTwoWeeksAgo = new Date(
    inputDateObj.getFullYear(),
    inputDateObj.getMonth(),
    inputDateObj.getDate() - 14
  );

  const checkCurrentWeekCondition = (
    currentDate,
    tuesdayDate,
    startDate,
    endDate,
    weekDay,
    hasPassed5AM
  ) => {
    if (currentDate >= startDate && currentDate <= endDate && tuesdayDate >= startDate) {
      if ((weekDay === 2 && hasPassed5AM) || weekDay > 2) {
        return true;
      }
    }
    return false;
  };

  const checkConditionTwoWeeksAgo = (
    currentDateTwoWeeksAgo,
    tuesdayDateTwoWeeksAgo,
    startDate,
    endDate,
    weekDay,
    hasPassed5AM
  ) => {
    if (
      currentDateTwoWeeksAgo >= startDate &&
      currentDateTwoWeeksAgo <= endDate &&
      tuesdayDateTwoWeeksAgo >= startDate
    ) {
      if (weekDay < 2 || (weekDay === 2 && !hasPassed5AM)) {
        return true;
      }
    }
    return false;
  };

  for (const weekKey in weekObject) {
    if (Object.prototype.hasOwnProperty.call(weekObject, weekKey)) {
      const week = weekObject[weekKey];
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      const returnObjBlockForMonthandWeek = {
        fiscal_month: week.fiscal_month,
        week: weekKey,
      };

      if (
        checkCurrentWeekCondition(
          currentDate,
          tuesdayDate,
          startDate,
          endDate,
          weekDay,
          hasPassed5AM
        ) ||
        checkConditionTwoWeeksAgo(
          currentDateTwoWeeksAgo,
          tuesdayDateTwoWeeksAgo,
          startDate,
          endDate,
          weekDay,
          hasPassed5AM
        )
      ) {
        return returnObjBlockForMonthandWeek;
      }
    }
  }
  return null;
}

// transformedDataWithDate should be sent as a input, output of findWeekAndMonth will be object with fiscal_month and week key
export function findWeekAndMonth(data) {
  for (const quarterKey in data) {
    if (Object.prototype.hasOwnProperty.call(data, quarterKey)) {
      const weeks = Object.values(data[quarterKey]);
      for (const week of weeks) {
        if (typeof week === 'object') {
          const result = findFiscalMonthAndWeek(week);
          if (result) {
            return result;
          }
        }
      }
    }
  }
  if (data?.length > 0) {
    console.log('Error in findWeekAndMonth as data is passed and week calculation issue--->');
  }
  return null;
}

export const isLeapYear = (year) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

// this function is also used globally where calendar is used
// subtractValue should be 1 always if not passed as we are calculating data from the previous week
export const previousWeekExtractor = (transformedDataWithDate, subtractValue = 0) => {
  const currentWeek = parseInt(findWeekAndMonth(transformedDataWithDate)?.week?.slice(1));
  const currentYear =
    currentWeek === (53 || 52)
      ? transformedDataWithDate[1]?.currYear
      : transformedDataWithDate[0]?.currYear; // to handle the year for the selected week
  // the input year should be current year -1 as we will compare current year data with last year weeks
  const numberOfWeeksInLastYear = isLeapYear(currentYear - 1) ? 53 : 52;
  // -4 value is subtracted because want the data from the previous five weeks and current week is included
  const weekValueAfterSubtraction = currentWeek - subtractValue;
  if (weekValueAfterSubtraction <= 0) {
    // - - = + hence + added for the subtraction in return for numberOfWeeksInLastYear + weekValueAfterSubtraction
    return {
      filter: `${currentYear - 1}${numberOfWeeksInLastYear + weekValueAfterSubtraction}`,
      subtractedWeekValue: numberOfWeeksInLastYear + weekValueAfterSubtraction,
      currentWeek: currentWeek,
      currentYear: currentYear - 1,
    };
  } else {
    return {
      filter: `${currentYear}${String(weekValueAfterSubtraction)?.padStart(2, '0')}`,
      subtractedWeekValue: weekValueAfterSubtraction,
      currentWeek: currentWeek,
      currentYear: currentYear,
    };
  }
};
